<template>
  <play-pause-btn class="tts-play-pause-btn" :playing='playing' :started='started' @play-pause='handlePlayPause'/>
</template>

<script>
import { inject, defineComponent } from 'vue';
import { useEvent } from '../../plugins/vue-gtag';
import PlayPauseBtn from './PlayPauseBtn.vue';

export default defineComponent({
  components: {
    PlayPauseBtn,
  },
  setup(){
    const playing = inject('playing', undefined);
    const started = inject('started', undefined);
    const gaStartTts = useEvent('start_tts');
    const gaResumePauseTts = useEvent('resume_pause_tts');
    const ttsPlayPause = inject('handlePlayPause', undefined);

    const handlePlayPause = (...args)=>{
      if (!started.value){
        gaStartTts();
      } else {
        gaResumePauseTts(!playing.value ? 'resume' : 'pause');
      }

      ttsPlayPause(...args);
    }

    return {
      playing,
      started,
      handlePlayPause
    }
  }
})
</script>
